import { ButtonView } from '@vivli/shared/views';
import { Size, Styles } from '@vivli/shared/theme';
import { CSSProperties } from 'react';
import { useModalApiContext } from '@vivli/core/infrastructure/context';
import { DTICommonConst } from '@vivli/shared/infrastructure/constants';
import { LoggerService } from '@vivli/shared/infrastructure/service';

const genericStyle: CSSProperties = {
    marginTop: Size.FIELD_SEPARATION,
    marginBottom: Size.FIELD_SEPARATION
};

const oneAcrossStyleSmallNoBox: CSSProperties = {
    ...genericStyle,
    flex: '1 1 100%',
    maxWidth: '20%',
    marginLeft: 'auto',
    marginRight: 'auto'
};

interface AddStudyInProcessComponentProps {
    studySingularName: string;
    studyPluralName: string;
    isAmr: boolean;
    addUnlistedStudy?: () => void;
    addInProcessStudy?: (id: string) => void;
}

export const AddStudyInProcessComponent = ({
    studySingularName,
    studyPluralName,
    isAmr,
    addUnlistedStudy,
    addInProcessStudy
}: AddStudyInProcessComponentProps) => {
    const modal = useModalApiContext();
    const studiesName = studyPluralName.toLowerCase();
    const studyCapitalized = studySingularName.charAt(0).toUpperCase() + studySingularName.slice(1);
    const studiesDescript = isAmr ? `${studyCapitalized}` : `Vivli Listed ${studyCapitalized}`;

    const modalTitle = `Add ${studiesDescript} to this Data Request`;
    const message = `During drafts/revision, you can add ${studiesName} from any organization and include request review. In other stages, you can only add ${studiesName} from organizations already included in this request and skip the request review.`;
    const addListedButtonLabel = isAmr ? 'Add ${studyCapitalized}' : `Add Listed ${studyCapitalized}`;
    const confirmButtonText = `Add ${studyCapitalized}`;

    const handleResult = (id: string) => {
        LoggerService.log('id provided is ' + id);
        addInProcessStudy(id);
    };

    const handleAddStudy = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const modalId = modal.confirm(message, {
            title: modalTitle,
            style: { textAlign: 'left', minWidth: '50em' },
            messageStyle: { textAlign: 'left' },
            showMultiSelect: false,
            showTextAreaPrompt: true,
            showPrompt: false,
            promptLabel: `Enter NCT ID or Sponsor Protocol ID`,
            confirmText: `${confirmButtonText}`,
            cancelText: 'Cancel',
            onConfirm: ({ comment }) => {
                handleResult(comment);
                modal.dismiss(modalId);
            }
        });
    };

    return (
        <div style={{ marginTop: '20px' }}>
            <div style={Styles.FORM_ROW}>
                <ButtonView
                    style={oneAcrossStyleSmallNoBox}
                    onClick={(e) => {
                        handleAddStudy(e);
                    }}
                    dataId={DTICommonConst.AddButton}
                >
                    {addListedButtonLabel}
                </ButtonView>
                {!isAmr && (
                    <ButtonView
                        style={oneAcrossStyleSmallNoBox}
                        onClick={(e) => {
                            addUnlistedStudy();
                        }}
                        dataId={DTICommonConst.AddStudy}
                    >
                        Add Unlisted Study
                    </ButtonView>
                )}
            </div>
        </div>
    );
};
